import React, { createContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import Modal from 'react-bootstrap/Modal';
import ItemProtocolo from './ItemProtocolo';
import CrearEditProtocolo from './CrearEditProtocolo';
import ContenidoProtocolo from './ContenidoProtocolo';
import ModalCargando from '../utilsComponentes/ModalCargando';
import ModalMensajeInteractivo from '../utilsComponentes/ModalMensajeInteractivo';
import AdministrarCategoria from './AdministrarCategoria';
const server = process.env.REACT_APP_SERVER;
export const ContextoAdminProtocolo = createContext();
function PrincipalAdminProtocolo() {
    const [protocolos, setProtocolos] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [regional, setRegional] = useState('');
    const [actualizar, setActualizar] = useState(false);
    const [info, setInfo] = useState({});
    const [tituloModal, setTituloModal] = useState('');
    const [ventana, setVentana] = useState(0);
    const [loader, setLoader] = useState(false);
    const [tipoModal, setTipoModal] = useState('');
    const [modalAlerta, setModalAlerta] = useState(false);
    const [modalCambio, setModalCambio] = useState(false);
    const [areas, setAreas] = useState([]);
    const [idArea,setIdArea] = useState(-1);
    function guardarContenido(datoInfo, datoMenu) {
        fetch(`${server}/protocolos/guargarContenido`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, info: datoInfo, menu: datoMenu,idEmpleado:JSON.parse(localStorage.getItem('info')).ID_EMPLEADO
            })
        })
            .then(res => res.json())
            .then(data => {
                setModalShow(false);
                setLoader(false);
                if (data.ok) {
                    setActualizar(!actualizar);
                    setVentana(0);
                    MsgUtils.msgCorrecto(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => { setLoader(false); MsgUtils.msgError(err) });
    }
    function copiarContenido(tipo, dato) {
        setVentana(3);
        var datos = info;
        datos.ID_VERSION_ACTIVA = dato.V_ID;
        datos.VERSION_ACTIVA = dato.V_VERSION;
        datos.ID_EMPLEADO = dato.V_ID_EMPLEADO;
        delete datos.MENU
        delete datos.VERSIONES
        fetch(`${server}/protocolos/getProtocolos`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, idVersion: tipo, idProtocolo: info.ID_PROTOCOLO
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    var menu = data.ok[0].MENU;
                    for (var men of menu) {
                        men.ID_PROTOCOLO_PASO = 0
                        for (var conte of men.CONTENIDO) {
                            conte.ID_ADJUNTO = 0
                        }
                        for (var subm of men.SUBMENU) {
                            subm.ID_PROTOCOLO_PASO = 0;
                            for (var contee of subm.CONTENIDO) {
                                contee.ID_ADJUNTO = 0
                            }
                        }
                    }
                    guardarContenido(datos, menu);
                } else {
                    MsgUtils.msgError(data.error);
                    setLoader(false);
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function crearNuevaVersion(tipo) {
        if (tipo !== '-1') {
            setLoader(true);
            var creador = JSON.parse(localStorage.getItem('info')).ID_EMPLEADO;
            fetch(`${server}/protocolos/addVersionProtocolo`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional, ID_PROTOCOLO: info.ID_PROTOCOLO, VERSIONES: info.VERSIONES.length, creador
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        if (tipo === '-2') {
                            setActualizar(!actualizar);
                            setLoader(false);
                            setModalShow(false);
                        } else {
                            copiarContenido(tipo, data.ok);
                        }
                    } else {
                        MsgUtils.msgError(data.error);
                        setLoader(false);
                    }
                })
                .catch(err => MsgUtils.msgError(err));
        } else {
            MsgUtils.msgError("ELIJA UNA VERSION PARA COPIAR CONTENIDO");
        }
    }
    function cambiarEstado(tipo) {
        var dato = info;
        delete dato.VERSIONES;
        delete dato.MENU;
        fetch(`${server}/protocolos/changeVersionEstado`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, ...dato, CHANGE: tipo,idEmpleado: JSON.parse(localStorage.getItem('info')).ID_EMPLEADO
            })
        })
            .then(res => res.json())
            .then(data => {
                setInfo({});
                setModalAlerta(false);
                setModalCambio(false);
                if (data.ok) {
                    setVentana(0);
                    setActualizar(!actualizar);
                    MsgUtils.msgCorrecto(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    const eliminarProtocolo = (tipo) => {
        if (tipo) {
            cambiarEstado('E');
        } else {
            setInfo({});
            setModalAlerta(false);
        }
    }
    function getTamanio() {
        switch (tipoModal) {
            case 'B':
                return 'xl'
            case 'A':
                return 'sm'
            case 'C':
                return 'md'
            default:
                return 'sm'
        }
    }
    function getProtocolos(reg,ida) {
        setProtocolos([]);
        setLoader(true);
        fetch(`${server}/protocolos/getProtocolos`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional:reg, idVersion: -1, idProtocolo: -1,idArea:ida
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setProtocolos(data.ok);
                    setVentana(0);
                } else {
                    MsgUtils.msgError(data.error)
                }
                setLoader(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function cambioArea(valor){
        setIdArea(valor);
        getProtocolos(regional,valor);
    }
    useEffect(() => {
        setLoader(true);
        var reg = JSON.parse(localStorage.getItem("__react_session__")).regional
        if (regional === '') {
            setRegional(reg);
        }
        fetch(`${server}/protocolos/getAreas`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional:reg
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.ok) {
                    setAreas(data.ok);
                    getProtocolos(reg,idArea);
                } else {
                    MsgUtils.msgError(data.error)
                }
                setLoader(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }, [actualizar])
    return (
        <ContextoAdminProtocolo.Provider value={{
            regional, actualizar, setActualizar, setModalShow, setTituloModal, setModalCambio,
            setInfo, info, setVentana, setLoader, setTipoModal, modalAlerta, setModalAlerta,areas,idArea
        }}>
            {ventana == 0 && <div className='container-fluid py-2'>
                <div className='row row-cols g-1'>
                    <div className='col' style={{ maxWidth: '300px', minWidth: '200px' }}>
                        <div className='input-group'>
                            <label className='text-dark my-auto mx-2 fw-bold' >Departamento</label>
                            <select className="form-select form-select-sm btn-secondary " 
                                value={idArea} onChange={(e) => cambioArea(e.target.value)}>
                                <option value={-1}>TODOS</option>
                                {areas.map((item, index) => {
                                    return (
                                        <option key={index} value={item.ID_CATEGORIA}>{item.CATEGORIA}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '200px', minWidth: '200px' }}>
                        <button className='btn btn-sm btnNaranja fw-bold w-100'
                            onClick={() => { setTipoModal('A'); setModalShow(true); setTituloModal("Crear Nuevo Protocolo"); setInfo({}) }}>
                            <i className="fa-solid fa-circle-plus "></i> Nuevo Protocolo
                        </button>
                    </div>
                {/* 
                    <div className='col' style={{ maxWidth: '200px', minWidth: '200px' }}>
                        <button className='btn btn-sm btn-secondary fw-bold w-100'
                            onClick={() => { setTipoModal('C'); setTituloModal("Administrar Categorias de Protocolos"); setModalShow(true); }}>
                            <i className="fa-solid fa-clipboard-check"></i> Admin. Categorias
                        </button>
                    </div>*/}
                </div>
            </div>}
            {ventana == 0 && <div className='table-responsive'>
                <table className="table table-sm table-striped table-bordered border-secondary" style={{ tableLayout: 'fixed', width: '%' }}>
                        <caption>Lista de protocolos</caption>
                        <thead className='bg-dark bg-gradient text-light fs-bold'>
                            <tr className='text-center'>
                            <th className="col-3">CREADO POR</th>
                            <th className="col-4">PROTOCOLO</th>
                            <th className='col-1'>VERSIONES</th>
                            <th className='col' >DEPARTAMENTOS</th>
                            <th className="col-2" style={{ width:'200px' }}>ACCIONES</th>
                            </tr>
                        </thead>
                        <tbody>
                            {protocolos.map((item, index) => (
                            <ItemProtocolo info={item} key={index} />
                            ))}
                        </tbody>
                        </table>
            </div>}
            {ventana == 1 && <ContenidoProtocolo />}
            <Modal show={modalShow} onHide={() => setModalShow(false)}
                size={getTamanio()}
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>{tituloModal}</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0 px-2'>
                    {tipoModal === 'A' && <CrearEditProtocolo />}
                    {tipoModal === 'B' && info.VERSIONES !== undefined &&
                        <div className='container-fluid py-1'>
                            <div className="alert alert-primary d-flex align-items-center m-0 p-0" >
                                <i className="fa-solid fa-circle-info fa-2xl"></i>
                                <div className='px-2'>
                                    Elija una version, para copiar el contenido a la nueva version que estas creando !!!
                                </div>
                            </div>
                            <div className='container-fluid py-2'>
                                <select className="form-select form-select-sm bg-secondary text-light"
                                    onChange={(e) => crearNuevaVersion(e.target.value)}>
                                    <option value='-1'>NINGUNO</option>
                                    {info.VERSIONES.map((dato, id) => {
                                        return (
                                            <option value={dato.ID_VERSION} key={id}>Copiar Contenido de la Version {dato.VERSION}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="alert alert-primary d-flex align-items-center m-0 p-0" >
                                <i className="fa-solid fa-circle-info fa-2xl"></i>
                                <div className='px-2'>
                                    Si quiere crear la nueva version sin contenido, entrar a OMITIR !!
                                </div>
                            </div>
                            <div className='container-fluid py-2 '>
                                <button className='btn btn-sm btn-secondary w-100'
                                    onClick={() => crearNuevaVersion('-2')}
                                ><i className="fa-solid fa-plus"></i> OMITIR</button>
                            </div>
                        </div>}
                    {tipoModal === 'C' && <AdministrarCategoria />}
                </Modal.Body>
            </Modal>
            <Modal show={modalCambio} onHide={() => setModalCambio(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>{tituloModal}</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0 px-2'>
                    <div className='container-fluid py-2'>
                        <ul className="list-group text-center ">
                            <li className={`list-group-item list-group-item-action m-0 p-0 ${info.ESTADO === 'P' ? 'itemMenuOk' : 'bg-secondary'}`}>
                                <button className='btn btn-sm w-100 text-light fw-bold' onClick={() => cambiarEstado('P')}>PENDIENTE</button></li>
                            <li className={`list-group-item list-group-item-action m-0 p-0 ${info.ESTADO === 'R' ? 'itemMenuOk' : 'bg-secondary'}`}>
                                <button className='btn btn-sm w-100 text-light fw-bold' onClick={() => cambiarEstado('R')}>RECHAZADO</button></li>
                            <li className={`list-group-item list-group-item-action m-0 p-0 ${info.ESTADO === 'A' ? 'itemMenuOk' : 'bg-secondary'}`}>
                                <button className='btn btn-sm w-100 text-light fw-bold' onClick={() => cambiarEstado('A')}>APROBADO</button></li>
                        </ul>
                    </div>
                </Modal.Body>
            </Modal>
            <ModalMensajeInteractivo msg={tituloModal} collback={eliminarProtocolo} show={modalAlerta} />
            <ModalCargando show={loader} />
        </ContextoAdminProtocolo.Provider>
    )
}

export default PrincipalAdminProtocolo
